// extracted by mini-css-extract-plugin
export default {"copyButton":"copy-button_copyButton__w+2d-","icon":"copy-button_icon__x9hiu"};